// Default pagination values
export const TAKE = 20;
export const SKIP = 0;

// Infinite scroll
export const INFINITE_TAKE = 20;
